import styled from 'styled-components';
import { InfoCircleOutlined } from '@ant-design/icons';

export const StyledInfoCircleOutlined = styled(InfoCircleOutlined)`
  margin-left: 4px;
  color: #8c8c8c;
`;
